import { TinyEmitter } from "@expert/event-bus";

type ErrorEvents = {
    "error-occurred": unknown;
    "error-boundary-hit": unknown;
};
export const errorEventBus = new TinyEmitter<ErrorEvents>("temp-error-events-fired");
